"use client"

import { useIsMobile } from "@/hooks/use-mobile"
import { DesktopLayout } from "@/components/profile/desktop-layout"
import { MobileLayout } from "@/components/profile/mobile-layout"

export function Profile() {
  const isMobile = useIsMobile()

  if (isMobile === undefined) {
    return <DesktopLayout />
  }

  return isMobile ? <MobileLayout /> : <DesktopLayout />
}
